export async function cmsApiFetch<T>(
  url: URL | string,
  init?: RequestInit
): Promise<T> {
  const res = await fetch(url, init);
  if (!res.ok) {
    const errorText = await res.text();
    throw new Error(`CMS API request failed (${res.status}): ${errorText}`);
  }
  return res.json() as Promise<T>;
}
